module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAOdJREFUWEft0yEOwjAUxvHvZbsFZnKiZRLNJUChMCgkkgSJRGFQKBJOwA2wTYNCc409sqQsgQDrljYg3nS798u/eYQff/Tj+RCAFJACwQoURdEry/Lk1nplrT36rHgwgFKqD8A8hhLRyAcRDFANVkodAIzbIIICHGIPYOKLCA5wiB2AqQ8iCsAhtgBmTYhoAIfYAJh/Q0QFVIO11mtmXnxC1IA8z7M0TTOf3W17hpmHRLR8h6gBWuszMw/a/rzLeSK6WGtVdfd/ADGf4LVSkiRXY8ztqUCXlCHuRN+CJqQApIAUkAJS4A74SUshJN8PXwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/travel/icon_right.png
// module id = 8q02
// module chunks = 1